export const API_PREFIX = '/api/wandb';

export const forgeOrigin = (): string =>
  window.__FORGE_SHELL_CONFIG__?.origins?.forge ?? window.location.origin;

export const urlPrefixed = (path: string): string =>
  `${forgeOrigin().replace(/\/$/, '')}${API_PREFIX}${path}`;
